export function animateNumber(targetNumber, duration, dom) {
  if (targetNumber <= 0) return;

  let currentNumber = 0;
  let increment = targetNumber / (duration / 10);

  function formatNumber(number) {
    if (number >= 1000) {
      return number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return number.toFixed(0);
    }
  }

  function updateNumber() {
    currentNumber += increment;
    if (currentNumber >= targetNumber) {
      currentNumber = targetNumber;
      clearInterval(interval);
    }
    document.getElementById(dom).querySelector('b').innerHTML = formatNumber(Math.floor(currentNumber))
  }

  let interval = setInterval(updateNumber, 10);
}

export const advantage = [
  { tit: '年节福利', img: 1 },
  { tit: '电影福利', img: 2 },
  { tit: '生日福利', img: 3 },
  { tit: '图书福利', img: 4 },
  { tit: '数字权益', img: 10 },
  { tit: '餐兑福利', img: 12 },
  { tit: '个护劳保', img: 5 },
  { tit: '服装清洗', img: 6 },
  { tit: '旅疗休养', img: 7 },
  { tit: '健康体检', img: 8 },
  { tit: '乡村振兴', img: 9 },
  { tit: '定制服务', img: 11 },
]
export const funlist = [
  { tit: '品牌曝光', say: '平台拥有庞大的用户群体和流量，<br>可以帮助商家提升品牌知名度和影响力。', img: 1 },
  { tit: '智能推荐', say: '平台依托于强大的AI算法和数据分析能力，实现精准流量匹配，将商品精准投放到目标用户。 ', img: 2 },
  { tit: '运营赋能', say: '平台提供数据分析工具，<br>帮助商家了解平台数据，优化运营策略。', img: 3 },
  { tit: '智能客服', say: '7×24小时智能客服工具，协助商家<br>处理订单咨询、退换货等全流程服务。', img: 4 },
  { tit: '订单规模', say: '政企客户每年有大规模的采购需求，<br>且周期、预算明确，订单较为稳定。', img: 5 },
  { tit: '品牌背书', say: '政企采购需严审资质，入驻平台并成交，<br>彰显商家品牌与质量，提升市场信誉。', img: 6 },
  { tit: '结算保障', say: '政企客户的支付流程相对规范，<br>平台定期结算，避免了商家在回款上的风险。', img: 7 },
  { tit: '长期合作', say: '平台与客户建立了稳定合作关系，<br>有助于商家业务的可持续发展。', img: 8 },
  { tit: '市场拓展', say: '客户分布在全国各地，帮助商家<br>突破地域限制，触达新市场。', img: 9 }
]

export const ailist = [
  { tit: '账号注册', say: '填写注册信息，包括登录账号、密码、手机。', img: 1, href: 'https://service.casdt.cn/apply/#/login', hrefName: '立即注册' },
  { tit: '入驻申请', say: '上传企业资料，如入驻类目、 企业名称、营业执照等。', img: 2, href: 'https://service.casdt.cn/#/details?id=9', hrefName: '了解更多' },
  { tit: '平台审核', say: '平台审核时间一般约<br/> 为1-3个工作日。', img: 3 },
  { tit: '商品上架', say: '商家可根据操作手册<br/> 指导进行发布上架商品。', img: 4, href: 'https://service.casdt.cn/#/details?id=124', hrefName: '使用手册' },
  { tit: '正式运营', say: '日常商品维护，处理订单、<br/> 售后等运营工作。', img: 5 },
]


export const animate = (rf) => {
  const AnimateLeft = {
    origin: "left",
    distance: "1000px",
    opacity: 0,
    mobile: false,
    scale: 0.6,
    reset: false,
  }
  const AnimateRight = {
    origin: "right",
    distance: "1000px",
    opacity: 0,
    reset: false,
    scale: 0.6,
    mobile: false,
  }
  const AnimateTop = {
    origin: "top",
    distance: "200px",
    opacity: 0,
    mobile: false,
    reset: false,
    scale: 0.6,
  }
  const AnimateBottom = {
    origin: "bottom",
    distance: "200px",
    opacity: 0,
    reset: false,
    mobile: false,
    scale: 0.6,
  }
  const animateTo = (dom, animate, delay, rotate, duration) => {
    const newAnimate = { ...animate, delay: delay || 100, rotate: rotate || {}, duration: duration || 1000 }
    rf.reveal(dom, newAnimate)
  }
  const aboutAnimate = () => {
    animateTo('.about .phone', AnimateLeft, 0)
    animateTo('.about .htit', AnimateTop, 200);
    for (let i = 0; i < 3; i++) {
      animateTo(document.querySelectorAll('.about ul li')[i], AnimateTop, i * 200);
    }
    for (let i = 0; i < 4; i++) {
      animateTo(document.querySelectorAll('.about ol li')[i], AnimateRight, i * 100);
    }
  }

  const advantageAnimate = () => {
    animateTo('.advantage .htit', AnimateRight, 200);
    for (let i = 0; i < 3; i++) {
      animateTo(document.querySelectorAll('.advantage .cterbox li')[i], AnimateBottom, i * 100);
    }
    for (let i = 0; i < 12; i++) {
      animateTo(document.querySelectorAll('.piclist img')[i], AnimateBottom, i * 100, { y: 180 }, 1200);
    }
    animateTo('.advantage .longbox', AnimateLeft);
  }

  const processAnimate = () => {
    animateTo('.process .htit', AnimateLeft, 200);
    for (let i = 0; i < 5; i++) {
      animateTo(document.querySelectorAll('.process li')[i], AnimateRight, i * 300, { x: 180 }, 1200);
    }
  }

  const funAnimate = () => {
    animateTo('.funbox .htit', AnimateLeft, 200);
    for (let i = 0; i < 9; i++) {
      animateTo(document.querySelectorAll('.funbox li')[i], AnimateTop, i * 100, { y: -180 }, 1200);
    }
  }

  const lastAnimate = () => {
    animateTo('.brand .htit', AnimateTop, 100);
    animateTo('.brand ul', AnimateTop, 200);
    animateTo('.cooperate .htit', AnimateTop, 100);
    animateTo('.cooperate .kbox', AnimateTop, 200);
  }
  setTimeout(() => {
    aboutAnimate()
    advantageAnimate()
    processAnimate()
    funAnimate()
    lastAnimate()
  }, 100);

}

// const waveParams = {
//   phaseDelay: 0.18,
//   maxBrightness: 0.95
// };
// let i = 0;
// export function initAnimation(varColumns = 12, varRows = 8) {
//   const container = document.getElementById('banner');
//   container.innerHTML = '';
//   const { width, height } = container.getBoundingClientRect();
//   const fragment = document.createDocumentFragment();

//   // 生成碎片网格‌:ml-citation{ref="4" data="citationList"}
//   for (let x = 0; x < varColumns; x++) {
//     for (let y = 0; y < varRows; y++) {
//       const frag = document.createElement('div');
//       const fragWidth = width / varColumns;
//       const fragHeight = height / varRows;

//       frag.className = 'fragment';
//       frag.style.cssText = `
//         width: ${fragWidth}px;
//         height: ${fragHeight}px;
//         left: ${x * fragWidth}px;
//         top: ${y * fragHeight}px;
//         background-position: -${x * fragWidth}px -${y * fragHeight}px;
//         animation-delay: ${x * 0.08 + y * 0.03}s, 
//                         ${(x + y) * waveParams.phaseDelay}s; 
//       `;
//       fragment.appendChild(frag);
//     }
//   }
//   container.appendChild(fragment);
//   setTimeout(() => {
//     i++
//     container.className = 'newban' + ('nbg' + i)
//   }, 3000);
// }
const imgArr = [
  'https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/banner.png',
  'https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/banner1.jpg',
  'https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/banner2.jpg',
  'https://dyuit-front.oss-cn-hangzhou.aliyuncs.com/rules/banner3.jpg',
];


let isReverse = false;
export function createFragments(currentIndex) {
  // let isReverse = currentIndex % 2 == 0; // 方向标记‌:ml-citation{ref="1" data="citationList"}
  const container = document.getElementById('banner');
  container.innerHTML = '';
  const { width, height } = container.getBoundingClientRect();
  const fragment = document.createDocumentFragment();
  const varColumns = 12, varRows = 8;
  container.style.backgroundImage = "";
  // 动态计算相位差方向‌:ml-citation{ref="1,2" data="citationList"}
  // const phaseX = isReverse ? varColumns - x : x;
  // const phaseY = isReverse ? varRows - y : y;

  for (let x = 0; x < varColumns; x++) {
    for (let y = 0; y < varRows; y++) {
      const frag = document.createElement('div');
      const fragWidth = width / varColumns;
      const fragHeight = height / varRows;
      const phaseX = isReverse ? varColumns - x : x;
      const phaseY = isReverse ? varRows - y : y;
      frag.className = 'fragment';
      frag.style.cssText = `
        width: ${fragWidth}px;
        height: ${fragHeight}px;
        left: ${x * fragWidth}px;
        top: ${y * fragHeight}px;
        background-position: -${x * fragWidth}px -${y * fragHeight}px;
        background-image: url(${imgArr[currentIndex]});
        animation-delay: ${phaseX * 0.08 + phaseY * 0.03}s, 
                        ${(phaseX + phaseY) * 0.18}s;
      `;
      fragment.appendChild(frag);
    }
  }
  container.appendChild(fragment);
  setTimeout(() => {
    container.style.backgroundImage = "url(" + imgArr[currentIndex] + ")";
  }, 2000);

  isReverse = !isReverse; // 切换方向标记‌:ml-citation{ref="1" data="citationList"}
}

export function checkDeviceEnhanced() {
  const ua = navigator.userAgent;
  const platform = navigator.platform.toLowerCase();

  const isAndroid = /android|adr/i.test(ua) || platform.includes('linux arm');
  return isAndroid;
}